import { useContext } from 'react';
import { GenerateCombinedInvoicesXslJobContext } from './context';

export default function useGenerateCombinedInvoicesXslJobContext() {
  return useContext(GenerateCombinedInvoicesXslJobContext);
}
